import { clientAxios } from '@/plugins/axios'

const baseUrl = '/v1/setting/shop'

export const getShopInfo = (id = 2) => clientAxios.get(`${baseUrl}/detail/${id}`)
export const checkEmailDummy = (payload) => clientAxios.post(`${baseUrl}/mail/validate-email`, payload)
